import { render, staticRenderFns } from "./Queries.vue?vue&type=template&id=dd43952c&scoped=true&"
import script from "./Queries.vue?vue&type=script&lang=js&"
export * from "./Queries.vue?vue&type=script&lang=js&"
import style0 from "./Queries.vue?vue&type=style&index=0&id=dd43952c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd43952c",
  null
  
)

export default component.exports